// 답변 엔진(AI)에서 들어온 방문 판별(AEO·GEO 측정). referrer 호스트나 utm_source(ChatGPT는 utm_source=chatgpt.com을 붙인다)로 고른다.
// 결과는 GA4 이벤트 ai_referral(ai_source)과 문의 폼 유입 정보(attribution.ai_source)로 남는다.
// gatsby-node·테스트에서도 읽도록 CommonJS로 둔다.
const AI_SOURCES = [
  ['chatgpt', /(^|\.)(chatgpt\.com|chat\.openai\.com)$/],
  ['perplexity', /(^|\.)perplexity\.ai$/],
  ['gemini', /(^|\.)(gemini\.google\.com|bard\.google\.com)$/],
  ['copilot', /(^|\.)copilot\.microsoft\.com$/],
  ['claude', /(^|\.)claude\.ai$/],
  ['naver_cue', /(^|\.)cue\.search\.naver\.com$/],
  ['wrtn', /(^|\.)wrtn\.ai$/],
  ['deepseek', /(^|\.)chat\.deepseek\.com$/],
  ['grok', /(^|\.)grok\.com$/],
  ['you', /(^|\.)you\.com$/],
];

const hostOf = (value) => {
  if (!value) return '';
  try {
    return new URL(value.includes('://') ? value : `https://${value}`).hostname.toLowerCase();
  } catch (e) {
    return '';
  }
};

// referrer(URL)와 utm_source 중 하나라도 AI 서비스면 그 이름을, 아니면 ''
const detectAiSource = (referrer, utmSource) => {
  const hosts = [hostOf(referrer), hostOf(utmSource)];
  const hit = AI_SOURCES.find(([, re]) => hosts.some((h) => h && re.test(h)));
  return hit ? hit[0] : '';
};

module.exports = { detectAiSource, AI_SOURCES };
